/**
 * 基础配置信息
 */
const env = 'DEV'
export default {
    pageSize: 10,
    env: env,
    baseUrl: createBaseUrl(),
    host: window.location.host
}


function createBaseUrl() {
    // if (env === 'DEV') {
    //     return "http://localhost:8181"
    // }
    return "http://" + window.location.host + "/api"
}
